export const containerSymbol = Symbol('marp-vue-container');
export default { containerSymbol };
